import { landingPathForUser } from "@/modules/auth/domain/landing";
import { canAccessPath, shellForPath } from "@/modules/auth/domain/shellAccess";
import {
  resolveNotificationRoute,
  type InAppNotification,
} from "@/modules/sys/model/types";
import type { PushOpen } from "@/platform";

/**
 * Open the inbox route inside the shell the user is already in.
 * Does not approve, release, or otherwise act on the event.
 */
export function resolvePushTapPath(
  open: PushOpen,
  pathname: string,
  roles: readonly string[] | readonly { code: string }[],
): string | null {
  const note = toNotification(open);
  const pathShell = shellForPath(pathname);
  const landing = landingPathForUser(roles);
  const onOps =
    pathShell === "ops" || (pathShell == null && landing.startsWith("/ops"));
  const shell: "field" | "exe" =
    pathShell === "exe" || (pathShell == null && landing.startsWith("/exe"))
      ? "exe"
      : "field";

  if (onOps) {
    const hint = open.routeHint?.trim() ?? "";
    if (hint === "/ops" || hint.startsWith("/ops/")) return hint;
  }

  const resolved = resolveNotificationRoute(note, shell);
  if (!resolved) return null;
  if (!canAccessPath(roles, resolved)) return landing;
  return resolved;
}

function toNotification(open: PushOpen): InAppNotification {
  return {
    id: "push",
    eventType: open.eventType ?? "",
    title: "",
    body: "",
    severity: "info",
    entityType: open.entityType,
    entityId: open.entityId,
    plantCode: null,
    routeHint: open.routeHint,
    createdAt: "",
    readAt: null,
    isRead: false,
  };
}
